
export * from '../../frontend-js-dependencies-web/__liferay__/exports/dagre.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/dagre.js';
export default __default__;
